import { render, staticRenderFns } from "./BaixasRetornoBancario.vue?vue&type=template&id=d1894238&scoped=true&"
import script from "./baixasRetornoBancario.js?vue&type=script&lang=js&"
export * from "./baixasRetornoBancario.js?vue&type=script&lang=js&"
import style0 from "./BaixasRetornoBancario.vue?vue&type=style&index=0&id=d1894238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1894238",
  null
  
)

export default component.exports